import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

// Components
import AuthWrapper from './components/AuthWrapper';
import Layout from './components/Layout';
import AdminRoute from './components/AdminRoute';

// Pages
import HomePage from './pages/HomePage';
import TimelinePage from './pages/TimelinePage';
import ExhibitsPage from './pages/ExhibitsPage';
import AudioTranscriptsPage from './pages/AudioTranscriptsPage';
import LegalClaimsPage from './pages/LegalClaimsPage';
import LettersAffidavitsPage from './pages/LettersAffidavitsPage';

// Admin Pages
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminTimeline from './pages/admin/AdminTimeline';
import AdminExhibits from './pages/admin/AdminExhibits';
import AdminAudioTranscripts from './pages/admin/AdminAudioTranscripts';
import AdminLegalClaims from './pages/admin/AdminLegalClaims';
import AdminLettersAffidavits from './pages/admin/AdminLettersAffidavits';
import UserManagement from './pages/admin/UserManagement';
import DataMigration from './pages/admin/DataMigration';
import ImportPage from './pages/admin/ImportPage';

function App() {
  return (
    <BrowserRouter>
      <AuthWrapper>
        <Routes>
          {/* Regular user routes */}
          <Route path="/" element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="/timeline" element={<TimelinePage />} />
            <Route path="/exhibits" element={<ExhibitsPage />} />
            <Route path="/audio-transcripts" element={<AudioTranscriptsPage />} />
            <Route path="/legal-claims" element={<LegalClaimsPage />} />
            <Route path="/letters-affidavits" element={<LettersAffidavitsPage />} />
          </Route>
          
          {/* Admin routes */}
          <Route path="/admin" element={<AdminRoute />}>
            <Route index element={<AdminDashboard />} />
            <Route path="timeline" element={<AdminTimeline />} />
            <Route path="exhibits" element={<AdminExhibits />} />
            <Route path="audio-transcripts" element={<AdminAudioTranscripts />} />
            <Route path="legal-claims" element={<AdminLegalClaims />} />
            <Route path="letters-affidavits" element={<AdminLettersAffidavits />} />
            <Route path="users" element={<UserManagement />} />
            <Route path="data-migration" element={<DataMigration />} />
            <Route path="import" element={<ImportPage />} />
          </Route>
          
          {/* Catch-all redirect */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthWrapper>
    </BrowserRouter>
  );
}

export default App;